import {
    Grid,
    MenuItem,
    TextField,
} from '@mui/material';
import {AGENT_SKILL_TYPES, AgentSkill, AgentSkillType} from '../types/AgentSkillTypes';
import React, {useState} from 'react';

interface AgentSkillConfigFormProps {
    source?: AgentSkill;
    sourceType: AgentSkillType;
    onConfigurationChange: (configuration: Record<string, any>) => void;
    botId: string;
}

const AgentSkillConfigForm: React.FC<AgentSkillConfigFormProps> = ({
    source,
    sourceType,
    onConfigurationChange,
    botId
}) => {
    const [configuration, setConfiguration] = useState<Record<string, any>>(source?.configuration || {});

    // keep local config in sync with parent
    React.useEffect(() => {
        const initialConfig = source?.configuration || {};
        const fields = AGENT_SKILL_TYPES[sourceType]?.configurationFields || [];
        const hydratedConfig: Record<string, any> = {};

        fields.forEach(field => {
            hydratedConfig[field.key] = initialConfig[field.key] ?? field.defaultValue ?? '';
        });

        setConfiguration(hydratedConfig);
        onConfigurationChange(hydratedConfig); // propagate to parent too
        // eslint-disable-next-line
    }, [sourceType, source]); // re-run if sourceType or source changes

    const handleInputChange = (key: string, value: any) => {
        const newConfig = { ...configuration, [key]: value };
        setConfiguration(newConfig);
        onConfigurationChange(newConfig);
    };

    return (
        <Grid container spacing={2} sx={{ maxWidth: 600, mx: 'auto' }}>
            {AGENT_SKILL_TYPES[sourceType].configurationFields && AGENT_SKILL_TYPES[sourceType].configurationFields.map(field => (
                <Grid item xs={12} key={field.key}>
                    {field.type === 'select' ? (
                        <TextField
                            select
                            fullWidth
                            label={field.label + (field.read_only ? " (read-only)" : "")}
                            value={configuration[field.key] ?? ''}
                            onChange={(e) => handleInputChange(field.key, e.target.value)}
                            required={field.required}
                            disabled={(field.read_only ? field.read_only : false)}
                        >
                            {field.options?.map(option => (
                                <MenuItem key={option} value={option}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    ) : field.type === 'textarea' ? (
                        <TextField
                            multiline
                            rows={4}
                            fullWidth
                            label={field.label + (field.read_only ? " (read-only)" : "")}
                            value={configuration[field.key] ?? ''}
                            onChange={(e) => handleInputChange(field.key, e.target.value)}
                            required={field.required}
                            disabled={(field.read_only ? field.read_only : false)}
                        />
                    ) : (
                        <TextField
                            fullWidth
                            type={field.type}
                            label={field.label + (field.read_only ? " (read-only)" : "")}
                            value={configuration[field.key] ?? ''}
                            onChange={(e) => handleInputChange(field.key, e.target.value)}
                            required={field.required}
                            disabled={(field.read_only ? field.read_only : false)}
                        />
                    )}
                </Grid>
            ))}
        </Grid>
    );
};

export default AgentSkillConfigForm; 